import { render, staticRenderFns } from "./ErrorOverlay.vue?vue&type=template&id=f56e6034&"
import script from "./ErrorOverlay.vue?vue&type=script&lang=ts&"
export * from "./ErrorOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports